import { baseUrlManagement as management } from "lib/actions/endpoints/endpoints";

export const endpointsEntitlements = {
  getEntitlementsByWorkspaceId: (workspaceId: number) =>
    `${management}/workspaces/${workspaceId}/entitlements`,
  getEntitlementsByProjectId: (projectId: number) =>
    `${management}/projects/${projectId}/entitlements`,
};
